import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import Layout from "src/components/app/layout/Layout";
import Header from "src/components/app/layout/Header";
import CoachList from "src/components/app/appointments/CoachList";
import AppointmentList from "src/components/app/appointments/AppointmentList";

import { useAppDispatch } from "src/redux/hooks";
import * as actions from "src/redux/slices/appointmentsSlice";
import { SCREEN_NAMES } from "src/helpers/analytics/events";
import analytics from "src/helpers/analytics";

export const BookConsultationScreen: React.FC = () => {
  const navigate = useNavigate();
  const params = useParams();
  const supportProgramKey = params["support-program-key"];
  const dispatch = useAppDispatch();

  useEffect(() => {
    // Event: BOOK_CONSULTATION_SCREEN_VIEWED
    analytics.pageView(SCREEN_NAMES.BOOK_CONSULTATION_SCREEN);
  }, []);

  return (
    <Layout supportProgramKey={supportProgramKey || ""}>
      <div style={{ height: "calc(100vh - 75px)" }} className="relative">
        <div className="right-0 z-10">
          <Header
            title="Book Consultation"
            titlePosition="center"
            onBackClick={() => {
              dispatch(actions.clearCoach());
              navigate(`/app/${supportProgramKey}/home-screen`);
            }}
          />
        </div>
        {/* Horizontal Scroll Section and history section */}
        <div className="p-4">
          <CoachList />
          <div className="h-full">
            <AppointmentList />
          </div>
        </div>
      </div>
    </Layout>
  );
};
